import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import {QuizType, QuizTypeData} from "../../types/QuizType";
import deserializeQuizType from "./deserializers/quiz-type";

/**
 * Get all quiz types (paginated)
 */
const all = async (page: number = 1) => {
    const response = await client.get<DataPage<QuizType> | null>(`/quiz-types?page=${page}`)

    if(response.data){
        response.data.data = response.data.data.map(deserializeQuizType)
    }

    return response.data
}

/**
 * Get a single quiz type
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<QuizType>(`/quiz-types/${id}`)
    return response.data? deserializeQuizType(response.data) : null
}

/**
 * Store a new quiz type
 *
 * @param data
 */
const store = async (data: QuizTypeData) => {
    const response = await client.post<QuizType>('/quiz-types', data)
    return response.data? deserializeQuizType(response.data) : null
}

/**
 * Update an existing quiz type
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: QuizTypeData) => {
    const response = await client.put<QuizType>(`/quiz-types/${id}`, data)
    return response.data? deserializeQuizType(response.data) : null
}

/**
 * Permanently delete a quiz type
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/quiz-types/${id}`)
    return response.status === 204
}

const quizTypes = {
    all,
    get,
    store,
    update,
    destroy
}

export default quizTypes;